import { ContentBlockViewComponent, ContentModule } from '@tytapp/content';
import { LiveStreamBlock } from './live-stream-block';
import { Component, HostBinding, inject } from '@angular/core';
import { LiveStreamsService } from '../live-streams.service';
import { ApiLiveStream } from '@tytapp/api';
import { MediaPlaybackModule, Playback } from '@tytapp/media-playback';
import { ChatModule } from '@tytapp/chat';

@Component({
    selector: 'tyt-live-stream-block',
    standalone: true,
    imports: [ ContentModule, MediaPlaybackModule, ChatModule ],
    template: `
        @if (stream && !collapsed) {
            @if (isPreview) {
                <a class="preview-wrapper" url="/live/streams/{{ stream.id }}">
                    <div class="overlay">
                        <mat-icon>play_arrow</mat-icon>
                        {{ block.previewText ?? 'Watch Now' }}
                    </div>
                    <tyt-media-player
                        #player
                        [inEditor]="inEditor"
                        [isLive]="!stream.finished"
                        [inline]="true"
                        [stream]="stream"
                        [startMuted]="true"
                        [disablePip]="true"
                        [disableControls]="true"
                        [allowKeyboardControls]="false"
                        [disableAppTransfer]="true"
                        [autoplay]="block.autoplay"
                        [embed]="true"
                        />
                </a>
            } @else {
                <tyt-media-player
                    #player
                    [inEditor]="inEditor"
                    [isLive]="!stream.finished"
                    [inline]="true"
                    [stream]="stream"
                    [autoplay]="block.autoplay"
                    [embed]="true"
                    title="{{stream.title || stream.active_live_event?.title}}"
                    titleLink="/live/streams/{{ stream.id }}"
                    />
            }

            @if (block.showComments) {
                <tyt-comments [identifier]="topicIdentifier" url="/live/streams/{{stream.id}}" />
            }
        }
    `,
    styles: [`
        .preview-wrapper {
            position: relative;
            display: block;

            ::ng-deep tyt-media-player {
                &, & * {
                    pointer-events: none !important; // Seriously, listen to me!
                }
            }


            .overlay {
                background-color: rgba(0, 0, 0, 0.6);
                color: white;
                z-index: 2;
                position: absolute;
                inset: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 20pt;

                mat-icon {
                    $size: 48px;
                    font-size: $size;
                    width: $size;
                    height: $size;
                }
            }
        }
    `]
})
export class ViewComponent extends ContentBlockViewComponent<LiveStreamBlock> {
    private liveStreams = inject(LiveStreamsService);
    private playback = inject(Playback);

    @HostBinding('class.preview')
    get isPreview() { return this.block.isPreview; }

    collapsed = false;
    stream: ApiLiveStream;

    async onBlockChanged() {
        let stream = await this.liveStreams.getPreferredActiveLiveStream(this.block.prefer);
        if (stream) {
            this.stream = await this.liveStreams.get(stream.id); // needed to get the asset
        } else {
            this.stream = undefined;
        }

        this.collapsed = this.playback.currentStream?.id === this.stream.id;
    }

    get topicIdentifier() {
        if (!this.stream)
            return null;

        return this.liveStreams.getCommentsTopicIdentifierForStream(this.stream);
    }
}
